import Go from './go';

export default Go;
